import { useState } from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';

import Button from '../Button';
import { useAuth } from '../../hooks/auth';
import ApolloAuth from '../../services/apolloAuth';

import {
  Headline,
  Input,
  ButtonsContainer,
  Error,
  modalStyles,
} from './styles';

const modalCloseTimeout = 500;

const propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onSuccess: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

function getErrorMessage(err) {
  if (err.response?.status === 401) return 'Senha incorreta';

  return err.response?.data?.error || 'Ocorreu um erro';
}

const CheckPasswordModal = ({ isOpen, onSuccess, onClose }) => {
  const { userToken } = useAuth();
  const [value, setValue] = useState('');
  const [error, setError] = useState(null);

  async function handleConfirmButtonClick() {
    if (!value) return;

    try {
      await ApolloAuth.verifyPassword({ token: userToken, password: value });
      onSuccess();
      setTimeout(() => {
        setValue('');
      }, modalCloseTimeout);
    } catch (err) {
      setError(getErrorMessage(err));
    }
  }

  function handleInputChange(e) {
    setValue(e.target.value);
  }

  function handleCloseButtonClick() {
    onClose();

    setTimeout(() => {
      setValue('');
    }, modalCloseTimeout);
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleCloseButtonClick}
      contentLabel="Validar senha"
      style={modalStyles}
      closeTimeoutMS={modalCloseTimeout}
    >
      <Headline>Digite sua senha</Headline>
      <p>Informe qual é a senha da sua conta para finalizar a compra</p>
      <Input type="password" onChange={handleInputChange} value={value} />
      {error && <Error>{error}</Error>}
      <ButtonsContainer>
        <Button text="Cancelar" onClick={handleCloseButtonClick} />
        <Button text="Confirmar" primary onClick={handleConfirmButtonClick} />
      </ButtonsContainer>
    </Modal>
  );
};

CheckPasswordModal.propTypes = propTypes;

export default CheckPasswordModal;
